import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/user.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from 'selenium-webdriver/http';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {

  form = new FormGroup({
    
    year: new FormControl('', Validators.required),
  });
  ID: any;
  public data:any=[];
  ramki: any;

  constructor(public fb: FormBuilder,
    public usr:UserService,
    public toastr:ToastrService,
    ) { 
     let b = JSON.parse(localStorage.getItem('data'));
     this.ramki=b;
    }

  get f(){
    return this.form.controls;
  }
  ngOnInit(): void {

    this.usr.getYears().subscribe((res:any)=>
    {
      this.data=res.data;
      localStorage.setItem('years',JSON.stringify(this.data));
     this.ID = JSON.parse(localStorage.getItem('data'));
    })
  }

  
//   onOptionsSelected(value:string){
//     let obj={
//       'user_id':this.ID.user_id,
//       'year':value
//     }
//     this.usr.years(obj).subscribe((res:any)=>
//     {
//       // this.data = res.data;
//       if(res.code===200)
//       {
//         localStorage.setItem('newYear',obj.year);
//         this.toastr.success(res.message);
//       }else {
//         this.toastr.error(res.message);
//       }
//     })  
// }
}